import type { MutableRefObject } from "react";
import type { Am5ChartExportApi } from "./tarsAm5Exporting";

export type ChartCopyRef = MutableRefObject<(() => Promise<void>) | null>;
export type ChartExportRef = MutableRefObject<(() => Promise<Blob>) | null>;

export function bindAm5ExportRefs(
  api: Am5ChartExportApi | undefined,
  copyRef: ChartCopyRef,
  exportRef?: ChartExportRef
): void {
  copyRef.current = api?.copyToClipboard ?? null;
  if (exportRef) exportRef.current = api?.exportPngBlob ?? null;
}

export function clearAm5ExportRefs(copyRef: ChartCopyRef, exportRef?: ChartExportRef): void {
  copyRef.current = null;
  if (exportRef) exportRef.current = null;
}
